<!--app菜单配置页面-->
<template>
	<div>
		<div class="buttonLine" :style="$store.resourcesStore.getters.getBackgroudImageStyle('wedoButton/bar.png')">
			<iconButton @buttonClick='addMenu' buttonText='添加同级' icoName="wedoButton/add.png"></iconButton>
			<iconButton @buttonClick='addMenuChild' buttonText='添加子级' icoName="wedoButton/add.png"></iconButton>
			<iconButton @buttonClick='editMenu' buttonText='修改' icoName="wedoButton/edit.png"></iconButton>
			<iconButton @buttonClick='deleteMenu' buttonText='删除' icoName="wedoButton/delete.png"></iconButton>
			<iconButton @buttonClick='refresh' buttonText='刷新' icoName="wedoButton/delete.png"></iconButton>
		</div>
		<menuAppTree style="height: calc(100% - 50px);" @checkItem='checkItem' slot="tree"></menuAppTree>
	</div>
</template>

<script type="text/javascript">
	//窗口
	import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import menuAppTree from '@/components/module/tree/menuAppTree.vue'

	export default {
		components: {
			nomalInputDialog,
			menuAppTree,
			iconButton,
		},
		props: [],
		data() {
			return {
				nowMenu: undefined, //当前选中菜单
				previousIndex: -1,
				nextIndex: -1,
				parentid: '',
				previousItem: undefined,
				nextItem: undefined,
				nowMenuNextLastOneSort: 1,
				nowTheme: undefined,
			}
		},
		created() {
			debugPage = this
		},
		mounted() {},
		destroyed() {},
		computed: {
			themeSelect() {
				return this.$store.configStore.getters.getWebSkinList
			},
			getAppMenuTree() {
				return this.$store.menuStore.getters.getAppMenuTree
			},
		},
		watch: {
			nowTheme(nv, ov) {
			},
			previousIndex(nv, ov) {
				if(-1 != this.previousIndex && '' != this.parentid) {
					this.findItemByIndexAndParentid(this.getAppMenuTree, this.parentid, this.previousIndex, 'after')
				}
			},
			nextIndex(nv, ov) {
				if(-1 != this.nextIndex && '' != this.parentid) {
					this.findItemByIndexAndParentid(this.getAppMenuTree, this.parentid, this.nextIndex, 'next')
				}
			},
			getAppMenuTree(nv, ov) {
				if(isempty(nv) || isempty(this.nowMenu)) {
					return
				}
				this.findParentidOrIndex(this.getAppMenuTree, this.nowMenu.id)
			},
		},
		methods: {
			checkItem(item) {
				this.previousItem = undefined
				this.nextItem = undefined
				this.nowMenu = item
				this.findParentidOrIndex(this.getAppMenuTree, item.id)
			},
			//添加同级
			addMenu() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选同级级单位!")
					return
				}
				var parentid = "" //当前选中app菜单的父级id
				if(undefined != this.nowMenu.parentid) {
					parentid = this.nowMenu.parentid
				}
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('添加app菜单', [{
					name: '菜单名称',
					pkid: 'rightname'
				}, {
					name: '菜单路径',
					pkid: 'webpage',
				}], item => {
					//添加接口
					//var serialno = isempty(this.nextItem) ? this.nowMenu.serialno + 1 : (this.nowMenu.serialno + this.nextItem.serialno) / 2
					var serialno = this.nowMenu.serialno + 1
					this.$api.menuApi.saveMenu("", item.rightname, "appright", serialno, item.webpage, parentid, respon => {
						this.$dialogMethod.showMessage("添加成功!")
						//刷新页面
						this.refresh()
					}, respon => {
						err(respon)
					})
				})
			},
			//添加子级
			addMenuChild() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选中父级单位!")
					return
				}
				var parentid = this.nowMenu.id //当前选中app菜单的id
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('添加app菜单', [{
					name: '菜单名称',
					pkid: 'rightname'
				}, {
					name: '菜单路径',
					pkid: 'webpage',
				}], item => {
					//添加接口
					var serialno = this.nowMenuNextLastOneSort
					this.$api.menuApi.saveMenu("", item.rightname, "appright", serialno, item.webpage, parentid, respon => {
						this.$dialogMethod.showMessage("添加成功!")
						//刷新页面
						this.refresh()
					}, respon => {
						err(respon)
					})
				})
			},
			//修改
			editMenu() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选中要编辑的app菜单!")
					return
				}
				var id = this.nowMenu.id //当前选中app菜单的id
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('修改app菜单', [{
					name: '菜单名称',
					pkid: 'rightname',
					defaultValue: this.nowMenu.rightname
				}, {
					name: '菜单路径',
					pkid: 'webpage',
					defaultValue: this.nowMenu.webpage
				}], item => {
					//修改接口
					this.$api.menuApi.saveMenu(this.nowMenu.id, item.rightname,
						this.nowMenu.righttype, this.nowMenu.serialno, item.webpage, this.nowMenu.parentid, respon => {
							this.$dialogMethod.showMessage("修改成功!")
							//刷新页面
							this.refresh()
						}, respon => {
							err(respon)
						})
				})
			},
			//删除
			deleteMenu() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选中要删除的web菜单!")
					return
				}
				var id = this.nowMenu.id //当前选中app菜单的id
				var rightname = this.nowMenu.rightname //当前选中web菜单的名称
				this.$dialogMethod.openAgreeDialog("删除web菜单", "是否删除 " + rightname, () => {
					//删除接口
					this.$api.menuApi.deleteMenuById(id, respon => {
						this.$dialogMethod.showMessage(respon)
						this.nowMenu = undefined
						this.refresh()
					}, respon => {
						err(respon)
					})
				})
			},
			refresh() {
				this.$store.menuStore.commit("getAppMenuTree")
			},
			//上移
			removeUp() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选中要移动的app菜单!")
				}
				this.changeSort(this.nowMenu, this.previousItem)
			},
			//下移
			removeDown() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选中要移动的app菜单!")
				}
				this.changeSort(this.nowMenu, this.nextItem)
			},
			//修改sort
			changeSort(itemA, itemB) {
				if(isempty(itemA) || isempty(itemB)) {
					return
				}
				this.$api.menuApi.menuUpOrDown(itemA.id, itemB.id, respon => {
					//刷新页面
					this.refresh()
					this.previousItem = undefined
					this.nextItem = undefined
				}, respon => {
					err(respon)
				})
			},
			//查找当前选中节点的parentid和所在数组的index角标
			findParentidOrIndex(dataList, flagId) {
				for(var i = 0, len = dataList.length; i < len; i++) {
					var item = dataList[i]
					if(item.id == flagId) {
						this.parentid = item.parentid
						this.nextIndex = i + 1
						this.previousIndex = i - 1
						if(!isempty(item.next)) {
							this.nowMenuNextLastOneSort = item.next[item.next.length - 1].sort + 1
						} else {
							this.nowMenuNextLastOneSort = 1
						}
					} else if(!isempty(item.next)) {
						//找一下下级
						this.findParentidOrIndex(item.next, flagId)
					}
				}
			},
			//根据parentid和index查找对象
			findItemByIndexAndParentid(dataList, parentid, index, flag) {
				for(var i = 0, len = dataList.length; i < len; i++) {
					var item = dataList[i]
					if(index == i && '' != parentid && parentid == item.parentid) {
						if(flag == 'after') {
							this.previousItem = item
						} else if(flag == 'next') {
							this.nextItem = item
						}
					} else if(!isempty(item.next)) {
						//找一下下级
						this.findItemByIndexAndParentid(item.next, parentid, index, flag)
					}
				}
			},
			imgFile() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选择app菜单!")
					return
				}
				var dialog = this.$dialogMethod.createDialog(imgFileTreeDialog)
				dialog.open("链接图形文件", item => {
					this.$api.menuApi.saveIcon(this.nowMenu.id, item.url, respon => {
						this.refresh()
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			webPage() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选择app菜单!")
					return
				}
				var dialog = this.$dialogMethod.createDialog(webPageTreeDialog)
				dialog.open("链接网站页面", item => {
					this.$api.menuApi.saveTag(this.nowMenu.id, item.url, respon => {
						this.refresh()
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			}

		}
	}
</script>

<style scoped>
	.rigth {
		float: left;
		height: 100%;
		width: 100%;
	}
	
	.monreportRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
	.entityTree {
		float: left;
		width: 2rem;
	}
</style>